import { NgModule } from '@angular/core';
import { ProgressErrorContainer } from './progress-error.container';

@NgModule({
  imports: [ ProgressErrorContainer ],
  exports: [ ProgressErrorContainer ]
})
export class ZefProgressErrorModule {

}
